module.exports = __webpack_public_path__ + "static/img/1001_big.116190e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1001_big.png
// module id = 3q40
// module chunks = 1